import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import React from "react";
import useDialogState from "@/hooks/useDialogState";
import CheckIcon from "@/icons/check.svg?react";
import PremiumDiamondIcon from "@/icons/premium_diamond.svg?react";
import PremiumDiamondBigIcon from "@/icons/premium_diamond_big.svg?react";

import "./style.scss";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const CheckItem = ({ text = "" }: { text?: string }) => (
  <div className="check-item">
    <CheckIcon /> {text}
  </div>
);

const FreemiumUpgradeModal: React.FC<Props> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    // `closeIcon={false}` stays explicit: this modal paints its own X in
    // `.close-icon-wrapper` below, and the Dialog is given no `title` (so Kendo
    // renders no titlebar) and no `onClose` — a titlebar X here would be dead.
    <Dialog className="freemium-upgrade-modal" width={750} closeIcon={false}>
      <div className="close-icon-wrapper" onClick={onClose}>
        <span className="k-icon k-font-icon k-i-close-outline" />
      </div>
      <div className="content-wrapper">
        <PremiumDiamondBigIcon className="premium-badge-icon" />
        <div>
          <h2>Unlock your Enterprise with Premium Features!</h2>
          <p>
            Experience unparalleled efficiency and innovation by unlocking
            premium features tailored for your enterprise needs
          </p>
        </div>
        <div className="check-items">
          <CheckItem text="All remediation actions" />
          <CheckItem text="Access controls policies" />
          <CheckItem text="Custom monitoring policies" />
          <CheckItem text="Integrations with Splunk, SSO, JIRA, etc." />
          <CheckItem text="All other data sources including additional snowflake accounts" />
        </div>
        <a
          href="mailto:sales@trustlogix.io"
          role="button"
          className="contact-sales-button"
        >
          <span className="k-icon k-font-icon k-i-email"></span> Contact Sales
        </a>
      </div>
    </Dialog>
  );
};

const FreemiumUpgradeButton: React.FC = () => {
  const [isOpenUpgradeModal, openUpgradeModal, closeUpgradeModal] =
    useDialogState();

  return (
    <>
      <Button
        size="medium"
        onClick={openUpgradeModal}
        className="freemium-upgrade-button"
      >
        <PremiumDiamondIcon height={18} width={18} />
        Upgrade
      </Button>
      <FreemiumUpgradeModal
        isOpen={isOpenUpgradeModal}
        onClose={closeUpgradeModal}
      />
    </>
  );
};

export default FreemiumUpgradeButton;
